import React from "react";
import {
  Image as ImageFragment,
  PDFImage,
} from "@sonder/ui/source/styled/fragments/Image";

interface ImageProps {
  isPDF?: boolean;
  src?: string;
}

export const isPDF = (src?: string) => src && src.includes(".pdf");

export const Image = (props: ImageProps) => {
  const { src, isPDF: isPDFHardcoded } = props;
  return isPDF(src) || isPDFHardcoded ? (
    <PDFImage {...props} />
  ) : (
    <ImageFragment {...props} />
  );
};
